import { createFileRoute } from "@tanstack/react-router";
import React from "react";

export const Route = createFileRoute("/$lang/about-us")({
  component: React.lazy(() =>
    import("@/pages/information/about-us").then((mod) => ({
      default: mod.AboutUs,
    })),
  ),
});
